module.exports = __webpack_public_path__ + "static/media/roemischesvorratslager.5b050994.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/roemischesvorratslager.jpg
// module id = 683
// module chunks = 0